import { type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Drawer } from './Drawer'
import { useSettingsDrawer } from './useSettingsDrawer'
import { SettingsBody } from './settings/SettingsBody'

/**
 * Drawer BODY mounted at app root alongside <LiveMatchSheet /> INSIDE the
 * <SettingsDrawerProvider> (App.tsx). Both this body and consumers (TopBar
 * cog via AppShell) share the same context instance through that provider.
 *
 * All handler logic lives in settings/SettingsBody + settings/SettingsActions.
 */
export function SettingsDrawer(): ReactElement {
  const { t } = useTranslation()
  const ctx = useSettingsDrawer()

  return (
    <Drawer open={ctx.isOpen} onClose={ctx.close} title={t('settings.title')}>
      <SettingsBody onClose={ctx.close} />
    </Drawer>
  )
}
